<script setup lang="ts">
import { useCmsSection } from "@shopware-pwa/composables-next";
import type { CmsSectionSidebar } from "@shopware-pwa/composables-next";
import { getTranslatedProperty } from "@shopware-pwa/helpers-next";
import { useCategory } from "#imports";
import { computed } from "vue";

const props = defineProps<{
  content: CmsSectionSidebar;
}>();
const { getPositionContent } = useCmsSection(props.content);

const sidebarBlocks = getPositionContent("sidebar");
const mainBlocks = getPositionContent("main");
const { category } = useCategory();
const isProductList = computed(() => category.value?.cmsPage?.type == "product_list");
</script>

<template>
  <div class="cms-section-sidebar">
    <div v-if="!isProductList" class="col-span-12 mx-8 md:mx-5 my-8">
      <h1 class="text-4xl font-extrabold tracking-tight text-gray-900">
        {{ getTranslatedProperty(category, "name") }}
      </h1>
    </div>

    <div v-if="isProductList" class="px-4" :class="{ 'product-wrap': !isProductList }">
      <div class="container mx-auto pt-0 pb-12 md:pt-12">
        <div class="grid grid-cols-12 gap-6">
          <div class="col-span-12 lg:col-span-3 w-full md:max-w-full lg:max-w-[203px]">
            <CmsGenericBlock
              v-for="cmsBlock in sidebarBlocks"
              :key="cmsBlock.id"
              :content="cmsBlock"
            />
          </div>
          <div class="col-span-12 lg:col-span-9 w-full max-w-[895px]">
            <CmsGenericBlock
              v-for="cmsBlock in mainBlocks"
              :key="cmsBlock.id"
              :content="cmsBlock"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
